<template>
  <v-app :dark="isDark">
    <v-card class="task-detail-card" :class="{ 'dark-mode': isDark }">
    <div v-if="currentTask">
<!--      <v-toolbar dark color="primary">-->
<!--        <v-btn icon @click="goBack">-->
<!--          <v-icon>mdi-arrow-left</v-icon>-->
<!--        </v-btn>-->
<!--        <v-toolbar-title>Детали задачи</v-toolbar-title>-->
<!--        <v-spacer></v-spacer>-->
<!--      </v-toolbar>-->

      <div class="task-detail-content">
        <!-- Task Info -->
        <div class="task-detail-section">
          <div class="section-title">
            <v-icon>mdi-file-tree</v-icon>
            <span>{{ currentTask.title }}</span>
          </div>
          <div class="task-description">
            {{ currentTask.description }}
          </div>
        </div>

        <!-- Date Info -->
        <div class="task-detail-section">
          <div class="section-title">
            <v-icon>mdi-calendar</v-icon>
            <span>{{ formatDate(currentTask.date) }}</span>
          </div>
        </div>

        <!-- Priority -->
        <div class="task-detail-section">
          <div class="section-title">
            <v-icon>mdi-flag</v-icon>
            <div class="task-priority" :class="currentTask.priority.toLowerCase()">{{ currentTask.priority }}</div>
          </div>
        </div>

        <!-- Location if available -->
        <div class="task-detail-section" v-if="currentTask.location">
          <div class="section-title">
            <v-icon>mdi-map-marker</v-icon>
            <span>{{ currentTask.location }}</span>
          </div>
        </div>

        <!-- Comments Section -->
        <div class="task-detail-section comments-section">
          <div class="section-title comments-title">
            <v-icon>mdi-comment-multiple-outline</v-icon>
            <span>Comments</span>
          </div>

          <div class="comments-list">
            <div v-for="(comment, index) in currentTask.comments" :key="index" class="comment-item">
              <div class="comment-header">
                <img :src="comment.avatar" class="comment-avatar" alt="Avatar">
                <div class="comment-author-info">
                  <div class="comment-author">{{ comment.author }}</div>
                  <div class="comment-time">{{ comment.time }}</div>
                </div>
              </div>
              <div class="comment-text">{{ comment.text }}</div>
            </div>

            <div class="no-comments" v-if="currentTask.comments.length === 0">
              No comments yet
            </div>
          </div>
        </div>
      </div>

      <!-- Action button -->
      <v-footer :dark="isDark" fixed>
        <v-btn block color="primary" class="white--text" height="56px" @click="prepareReport">
          Подготовить отчет
        </v-btn>
      </v-footer>
    </div>
  </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'TaskDetailScreen',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentTask: null,
      theme: 'light'
    };
  },
  computed: {
    isBridgeAvailable() {
      return require('@orta/bridge').isWebViewBridgeAvailable()
    },
    isDark() {
      return this.theme === 'dark';
    }
  },
  created() {
    // When component is created, fetch the task data
    console.log('TaskDetailScreen created with id:', this.id);
    console.log('Route params:', this.$route.params);

    // Get theme from route query param or localStorage
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';

    this.fetchTaskData();
  },
  mounted() {
    if (this.isBridgeAvailable) {
      require('@orta/bridge').setTitle('Детали задачи');
      require('@orta/bridge').backArrow.setMode(true);
      require('@orta/bridge').backArrow.setVisible(true);
      require('@orta/bridge').backArrow.setOnClickHandler(this.goBack);
    }
  },
  methods: {
    goBack() {
      // Look at the browser's history first
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        // If no history, go to home with theme preserved
        this.$router.push({ path: '/', query: { theme: this.theme } });
      }
    },
    prepareReport() {
      // Navigate to report creation screen with this task's ID
      console.log('Preparing report for task:', this.currentTask);

      // Save theme to localStorage for consistency
      localStorage.setItem('theme', this.theme);

      if (this.currentTask && this.currentTask.id) {
        // Use the currentTask.id to ensure we have the actual task data
        console.log('Navigating to report screen with task ID:', this.currentTask.id);
        this.$router.push({
          path: `/report/${this.currentTask.id}`,
          query: { theme: this.theme }
        });
      } else {
        console.warn('Cannot prepare report - no current task found');
        // If for some reason currentTask is missing, use the route param
        const taskId = this.id || this.$route.params.id;
        if (taskId) {
          console.log('Falling back to route param ID:', taskId);
          this.$router.push({
            path: `/report/${taskId}`,
            query: { theme: this.theme }
          });
        } else {
          console.error('No task ID available, cannot navigate to report screen');
        }
      }
    },
    formatDate(dateString) {
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day).toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
    },
    fetchTaskData() {
      // Get tasks from localStorage
      const storedTasks = localStorage.getItem('tasks');
      console.log('Stored tasks:', storedTasks);

      if (storedTasks) {
        const tasks = JSON.parse(storedTasks);
        // Convert both to string for comparison since route params are always strings
        const taskId = this.id || this.$route.params.id;
        console.log('Looking for task with id:', taskId);

        this.currentTask = tasks.find(task => String(task.id) === String(taskId));
        console.log('Found task:', this.currentTask);

        if (!this.currentTask) {
          console.warn('Task not found with id:', taskId);
          // If task not found, go back to home
          this.$router.push('/');
        }
      } else {
        console.warn('No stored tasks found');
        // No tasks found, go back to home
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.task-detail-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--bg-color) !important;
  border-radius: 0px !important;
}

.task-detail-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  margin-bottom: 56px; /* Space for fixed footer */
}

.task-detail-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--bg-color-secondary);
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-color);
}

.section-title .v-icon {
  margin-right: 8px;
  color: #757575;
}

.task-description {
  color: var(--text-color);
  line-height: 1.5;
  font-size: 16px;
}

/* Comments section */
.comments-section {
  border-bottom: none;
}

.comments-title {
  margin-bottom: 16px;
}

.comment-item {
  padding: 12px;
  margin-bottom: 12px;
  background-color: var(--bg-color-secondary);
  border-radius: 8px;
}

.comment-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.comment-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
}

.comment-author-info {
  flex: 1;
}

.comment-author {
  font-weight: 500;
  color: var(--text-color);
}

.comment-time {
  font-size: 12px;
  color: #757575;
}

.comment-text {
  color: var(--text-color);
  line-height: 1.4;
}

.no-comments {
  text-align: center;
  padding: 16px;
  color: #9E9E9E;
}

.task-priority {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.task-priority.высокий {
  background: #FFE5E5;
  color: #FF5757;
}

.task-priority.средний {
  background: #FFF4E5;
  color: #FF9F57;
}

.task-priority.норма {
  background: #E5FFE9;
  color: #57FF7C;
}

.task-priority.обычный {
  background: #E5F4FF;
  color: #579FFF;
}
</style>
